import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type Aside1DmaxInfoResponse,
    type MainInfoDmaxResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, TopSection } from "../common";
import { Aside1Section } from "../common/components/ctaSection";

export const About = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });
    return main && about && aside1 ? (
        <>
            <TopSection imgList={main?.imgList} sector={main?.sector} />
            <AboutSection data={about} />
            {/* <Location /> */}
            <Aside1Section data={aside1} />
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
